import { INSIGHT_ENDPOINTS } from '../endPoints';
import { apiRequest } from '../api';

export const getPricingAnalyticsWCA = (metadataId, fromDate, toDate) => {
  return apiRequest('get', INSIGHT_ENDPOINTS.GET_PRICING_ANALYTICS(metadataId, fromDate, toDate));
};

export const getMessageAnalyticsWCA = (metadataId, fromDate, toDate) => {
  return apiRequest('get', INSIGHT_ENDPOINTS.GET_MESSAGE_ANALYTICS(metadataId, fromDate, toDate));
};
